import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { path, propOr, pathEq, propEq, find, isEmpty } from 'ramda';
import { withAsyncActions, withSagas, toSuccess } from 'react-async-client';
import { translate } from 'react-translate-component';
import { takeEvery } from 'redux-saga/effects';
import { Spin } from 'antd';
import { withState } from 'recompose';

import {
    setWorksheetMassListFilters,
    setWorksheetMassListSort,
    setWorksheetMassListPagination,
    setWorksheetMassListColumnWidth
} from 'actions/worksheetMassActions';
import { fullAutoOptions } from 'constants/asyncClient';
import addWorksheetStage from '../../../sagas/worksheet';
import List from 'components/common/List';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import { defaultWorksheetMassColumns } from 'constants/defaultColumns';
import getWorksheetMassTableTemplate from './cellTemplates/worksheetMassTableTemplates';
import { getUser, getWorksheetMassList, getWorksheetMassListSettings, updateEvent, createEvent, postMassStage, getMassStages } from 'actions/asyncActions';
import WorksheetMassListControls from 'components/views/worksheetMassList/WorksheetMassListControls';
import WorksheetMassListButtons from 'components/views/worksheetMassList/WorksheetMassListButtons';

const getIsResponsible = pathEq(['data', 'responsible', 0, 'id']);

const tableConfig = {
    defaultColumns: defaultWorksheetMassColumns,
    getTemplate: getWorksheetMassTableTemplate,
    headerTranslatePrefix: 'worksheetMass.headers.',
};

const excludedTableConfig = {
    ...tableConfig,
    headerTranslatePrefix: 'worksheetMass.excludedHeaders.',
};

const dispatchToProps = {
    setPagination: setWorksheetMassListPagination,
    setSort: setWorksheetMassListSort,
    setFilters: setWorksheetMassListFilters,
    setColumnWidth: setWorksheetMassListColumnWidth
};

const getMassWorksheetParams = ({ match: { params: { id, stage } } }) => ({
    id,
    stage,
});

@withState('isResponsible', 'setResponsible', false)
@connect(({ table: { worksheetMass } }) => worksheetMass, dispatchToProps)
@withAsyncActions({
    getUser,
    getSettings: getWorksheetMassListSettings
        .withOptions({ dispatchOnMount: true }),
    getList: getWorksheetMassList
        .withParams(getMassWorksheetParams)
        .withPayload(({ pagination, match }) => ({
            ...getMassWorksheetParams({ match }),
            line: pagination.line,
        }))
        .withOptions(fullAutoOptions)
        .withSuccessHandler(
            ({ getUser, getList, setResponsible }) => (
                (getIsResponsible(getUser.data.id, getList)) && setResponsible(true)
            )
        ),
    getMassStages: getMassStages
        .withPayload(({ match: { params: { id } } }) => id)
        .withOptions(fullAutoOptions)
})
@withSagas([function* (getProps) {
    yield takeEvery([toSuccess(postMassStage.type), toSuccess(createEvent.type), toSuccess(updateEvent.type)], () => {
        getProps().getList.refresh();
    })},
    addWorksheetStage,
])
@withRouteOptions
export default class WorksheetMassListView extends Component {
    static routeOptions = {
        title: 'menu.worksheetMass'
    }

    static propTypes = {
        match: PropTypes.object.isRequired,
        getUser: PropTypes.object.isRequired,
        getList: PropTypes.object.isRequired,
        getSettings: PropTypes.object.isRequired,
        setHeaderTitle: PropTypes.func.isRequired,
        getMassStages: PropTypes.object,
        pagination: PropTypes.object,
        setPagination: PropTypes.func,
        selected: PropTypes.array,
        isResponsible: PropTypes.bool,
    }

    componentDidUpdate({ getList: { meta : oldMeta } }) {
        const { setHeaderTitle, getList: { meta, data } } = this.props;

        if (oldMeta.pending && meta.success) {
            setHeaderTitle({
                title: WorksheetMassListView.routeOptions.title,
                params: { project: path(['position', '0', 'text'], data) }
            });
        }
    }

    getSelectedStage() {
        const { data } = this.props.getMassStages;

        return find(propEq('id', Number(this.props.match.params.stage)))(data);
    }

    renderControls = (props) => {
        const { getList, getMassStages: { data, meta: { pending } }, setPagination, isResponsible } = this.props;
        const excludedTab = { id: 'excluded', name: translate('worksheetMass.excluded') };
        const spinTab = { id: 'spinTab', name: <Spin size='small' className='spin-in-tab' /> };
        const stages = pending ? [ spinTab ] : data;

        return (
            <WorksheetMassListControls
                {...props}
                refreshMeta={getList.meta}
                setPagination={setPagination}
                stages={isResponsible ? [...stages, excludedTab] : stages}
            />
        );
    }

    showWorksheet = () => {
        const { getMassStages: { meta, data } } = this.props;

        return meta.pending || !isEmpty(data);
    }

    render() {
        const { match, selected, ...props } = this.props;
        const { getList: { data, meta }, getSettings: { data : settings }, getMassStages } = this.props;
        const isExcludedTab = path(['params', 'stage'], match) === 'excluded';
        const hideGroups = !path(['hasSubStages'], this.getSelectedStage());
        const config = isExcludedTab ? excludedTableConfig : tableConfig;

        return this.showWorksheet() ? (
            <Fragment>
                <WorksheetMassListButtons selected={selected} params={match.params} projectId={data.id} />
                <List
                    className='mass-worksheet-table'
                    meta={meta}
                    items={propOr([], 'people', match.params.stage && data)}
                    settings={settings}
                    supportActions={[
                        getMassStages,
                    ]}

                    tableConfig={config}
                    controls={this.renderControls}
                    hideGroups={hideGroups}

                    {...props}
                />
            </Fragment>
        ) : (
            <div className='foreign-project'>
                Для просмотра сводки проекта Вы должны быть Ответственным или Соисполнителем.
            </div>
        );
    }
}
